import styled from 'styled-components'
import { styledVariant } from '../../../util'
import { inputStatusStyles } from '../../../shared/input-status'
import { SelectProps } from '../select.types'
import { AsyncSelectProps } from '../async-select.types'
import { BorderRadius } from '../../../theme/theme'

export interface StyledSelectInputProps {
  $status?: SelectProps['status'] | AsyncSelectProps['status']
  $disabled?: boolean
  $size?: SelectProps['size']
  $borderRadiiSize?: BorderRadius
}

export const StyledSelectTrigger = styled.div<StyledSelectInputProps>`
  ${styledVariant('$status', inputStatusStyles)};

  ${({ theme, $size, $borderRadiiSize }) => `
        position: relative;
        box-sizing: border-box;
        height: ${$size === 'medium' ? '3.25rem' : theme.sizes[10]};
        padding: ${theme.sizes[4]};
        border-radius: ${
          $borderRadiiSize
            ? theme.borderRadii[$borderRadiiSize]
            : theme.borderRadii.medium
        };
        background-color: white;
        display: flex;
        align-items: center;
        color: ${theme.colors.gray600};
        transition: 0.2s all;
        cursor: pointer;

        &:hover {
          border-color: ${theme.colors.black};
        }
        &:focus-within {
          border-color: ${theme.colors.black};
        }

        input {
          flex-grow: 1;
          padding: 0;
          padding-right: 20px;
          border: none;
          background-color: transparent;

          &:focus {
            outline: none;
            border: none;
          }
          &:active {
            outline: none;
            border: none;
          }
          ::placeholder {
            font-size: ${theme.fontSizes.bodySmall};
            font-weight: ${theme.fontWeights.regular};
            line-height: ${theme.sizes[5]};
            color: ${theme.colors.neutral300};
          }
        }
    `}

  ${({ theme, $disabled }) =>
    $disabled &&
    `
        background-color: ${theme.colors.gray80};
        outline: none;
        border: none;
        cursor: not-allowed;

      &:hover {
        outline: none;
        border: none;
      }
      &:focus {
        outline: none;
      }
      &:active {
        outline: none;
        border: none;
      }
    `}
`
